<template>
  <vue-draggable-resizable
    :active="true"
    :parent="false"
    :resizable="false"
    :w="705"
    :h="540"
    style="z-index: 100 !important; top: -2px;"
    :drag-handle="'.drag-photo'"
  >
    <loading-spinner
      :active.sync="loading"
      :is-full-page="false"
      color="accent"
    />
    <div class="card-container" v-if="!loading">
      <div class="flex-horizontal navbar-container  drag-photo">
        <ArrowSVG class="svg-style" @click="closeDialog" />
        <div class="flex-horizontal action-buttons-container">
          <v-btn class="photo-form-button" icon small color="accent">
            <v-icon size="20" @click="rotateRight">rotate_right</v-icon>
          </v-btn>
          <a :href="photoInBase64" :download="imageData.varName + '.jpg'">
            <v-btn class="photo-form-button" icon small color="accent">
              <v-icon size="15">vertical_align_bottom</v-icon>
            </v-btn>
          </a>

          <v-btn
            class="photo-form-button"
            @click="deletePhoto"
            icon
            small
            color="accent"
          >
            <v-icon size="15">delete</v-icon>
          </v-btn>
        </div>
      </div>
      <div
        class="flex-vertical main-content-container scroll-fire-fox"
        :style="`transform: rotate(${rotation}deg);`"
      >
        <img
          :src="photoInBase64"
          alt="photo"
          class="photo-image"
          @click="openImageOnOtherTab"
        />
      </div>
      <div style="width: 100%">
        <div class="photo-name">
          {{ imageData.label }}
          <EditSVG
            v-if="!disabled"
            class="edit-description-icon"
            :class="{ enabled: !editDisabled }"
            @click="toggleDescriptionEdition"
          />
        </div>
        <textarea
          v-model="photoDescription"
          :placeholder="$t('NoPhotoDescription')"
          class="photo-description"
          :class="{ enabled: !editDisabled }"
          :disabled="editDisabled"
          @keydown.prevent.enter="toggleDescriptionEdition"
        />
      </div>
    </div>
  </vue-draggable-resizable>
</template>

<script>
import ArrowSVG from "@/assets/sidebar/closeWindowArrow.svg";
import DownloadSVG from "@/assets/home/photosForm/download.svg";
import DeleteSVG from "@/assets/home/photosForm/delete.svg";
import EditSVG from "@/assets/home/photosForm/edit.svg";
import LoadingSpinner from "vue-loading-overlay";
export default {
  name: "PhotoOpened",

  components: {
    ArrowSVG,
    DownloadSVG,
    DeleteSVG,
    EditSVG,
    LoadingSpinner
  },

  props: {
    imageData: {
      type: Object,
      required: true
    },
    image: {
      type: String
    },
    thumb: {
      type: String
    },
    description: {
      type: String
    },
    uuid: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    photoCanBeClosed: {
      type: Boolean
    }
  },

  data() {
    return {
      photoDescription: "",
      editDisabled: true,
      photoInBase64: "",
      loading: false,
      rotation: 0
    };
  },

  mounted() {
    this.getLocalPhoto();
    this.getPhotoDescription();
  },

  methods: {
    closeDialog() {
      this.editDisabled = true;
      this.$emit("close");
    },
    deletePhoto() {
      this.$emit("removeImage");
    },
    updateDescription() {
      this.$emit("updateDescription", this.photoDescription);
    },
    getThumbPhoto() {
      this.photoInBase64 = this.$parent.getPhotoWithBase64(this.thumb);
      this.getPhotoFromServer();
    },
    getLocalPhoto() {
      if (this.image !== "" && this.image !== undefined) {
        this.photoInBase64 = this.$parent.getPhotoWithBase64(this.image);
      } else this.getPhotoFromServer();
    },
    getPhotoDescription() {
      if (this.description !== "" && this.description !== undefined) {
        this.photoDescription = this.description;
      }
    },
    getPhotoFromServer() {
      if (this.uuid) {
        this.loading = true;
        this.$store.dispatch("FETCH_IMAGE_BY_UUID", this.uuid).then(photo => {
          let photoCode;
          if (photo.image !== "") {
            photoCode = photo.image;
          } else {
            photoCode = photo.image_thumb;
          }
          this.photoInBase64 = this.$parent.getPhotoWithBase64(photoCode);
          this.loading = false;
        });
      }
    },
    rotateRight() {
      this.rotation += 90;
    },
    openImageOnOtherTab() {
      let image = new Image();
      image.src = this.photoInBase64;
      let w = window.open("");
      w.document.write(image.outerHTML);
      w.document.title = this.imageData.label;
      w.document.close();
    },
    toggleDescriptionEdition() {
      if (!this.editDisabled) {
        this.updateDescription();
      }
      this.editDisabled = !this.editDisabled;
    }
  },
  watch: {
    description() {
      this.getPhotoDescription();
    },
    image() {
      this.getLocalPhoto();
    },
    thumb() {
      this.getThumbPhoto();
    },
    photoCanBeClosed() {
      if (this.photoCanBeClosed) {
        this.closeDialog();
      }
    }
  }
};
</script>

<style scoped>
.card-container {
  height: 574px;
  width: 100%;
  transition: opacity 3s;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
}
.flex-horizontal {
  justify-content: space-between;
}
.navbar-container {
  width: 100%;
  margin-bottom: 16px;
}
.action-buttons-container {
  width: 60px;
  justify-content: flex-end;
}
.svg-style {
  margin-left: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.main-content-container {
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.photo-image {
  max-height: 100%;
  max-width: 100%;
  cursor: pointer;
}
.photo-name {
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  height: 20px;
}
.photo-description {
  font-size: 12px;
  line-height: 15px;
  width: 100%;
  margin: 5px;
  padding: 3px;
}
.photo-description.enabled {
  padding: 2px;
  border: 1px solid var(--active);
  border-radius: 2px;
  margin-top: 5px;
}
.edit-description-icon {
  margin-left: 10px;
  cursor: pointer;
}

.edit-description-icon.enabled * {
  fill: var(--active);
}
.edit-description-icon:hover * {
  fill: var(--hover);
}
.photo-form-button {
  margin-top: 1px;
  margin-right: 0px;
  width: 25px;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Photos/PhotoOpened.vue